import React from 'react';
import { Link } from 'react-router-dom';

const BlogPreview = ({ post, index = 0 }) => {
  const formattedDate = new Date(post.date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <article className={`mb-8 animate-on-load animate-fade-in-up animate-delay-${(index + 1) * 100}`}>
      <Link to={`/blog/${post.slug}`} className="block group">
        <time className="font-body text-ink-muted text-sm uppercase tracking-widest">
          {formattedDate}
        </time>
        <h3 className="font-serif text-xl md:text-2xl text-ink mt-2 mb-3 group-hover:text-accent transition-colors">
          {post.title}
        </h3>
        <p className="font-body text-ink-light leading-relaxed">
          {post.excerpt}
        </p>
        <span className="inline-block mt-3 font-body text-sm text-accent hover:text-accent-dark transition-colors">
          Read more →
        </span>
      </Link>
    </article>
  );
};

export default BlogPreview;



